import {
  materializeNativeGameplayEffect,
} from "./NativeGameplayEffectRuntime.js";
import { exactNativeIntegerValue } from "./NativeIntegerExpression.js";
export {
  createNativeActorByteStateSemanticHandlers,
} from "./NativeActorByteState.js";
export {
  createNativeNumericSemanticHandlers,
  nativeBinaryAngleFromFloatPairWords,
  nativeBinaryAngleCosineWord,
  nativeBinaryAngleSineWord,
  nativeFloat32FromWord,
  nativeFloat32Word,
} from "./NativeEventNumericRuntime.js";
export {
  createNativeSceneObjectSemanticHandlers,
} from "./NativeSceneObjectRuntime.js";
export {
  createNativeEfptControllerSemanticHandlers,
  createNativeEfptControllerState,
  NativeEfptControllerState,
} from "./NativeEfptControllerRuntime.js";
export {
  createNativeEfptPrimaryControllerSemanticHandlers,
  createNativeEfptPrimaryControllerState,
  NativeEfptPrimaryControllerState,
} from "./NativeEfptPrimaryControllerRuntime.js";
export {
  createNativeFixedFloatExchangeSemanticHandlers,
  createNativeFixedFloatExchangeState,
  NativeFixedFloatExchangeState,
} from "./NativeFixedFloatExchangeRuntime.js";
export {
  createNativeSpatialBoundsSemanticHandlers,
} from "./NativeSpatialBoundsRuntime.js";
export {
  createNativeObjectLinkSemanticHandlers,
} from "./NativeObjectLinkRuntime.js";
export {
  createNativeObjectFacingSemanticHandlers,
} from "./NativeObjectFacingRuntime.js";
export {
  createNativeCameraAuxiliarySemanticHandlers,
} from "./NativeCameraAuxiliaryRuntime.js";
export {
  createNativeFogTableSemanticHandlers,
} from "./NativeFogTableRuntime.js";
export {
  createNativeScrollSpriteSemanticHandlers,
} from "./NativeScrollSpriteRuntime.js";
export {
  createNativePresentationControlSemanticHandlers,
} from "./NativePresentationControlRuntime.js";
export {
  createNativeFaceTableSemanticHandlers,
} from "./NativeFaceTableRuntime.js";
export {
  createNativeObjectDword5cSemanticHandlers,
  createNativeObjectDword5cState,
  NativeObjectDword5cState,
} from "./NativeObjectDword5cRuntime.js";
export {
  createNativeGlobalControllerSemanticHandlers,
} from "./NativeGlobalControllerRuntime.js";
export {
  createNativeActorControllerWordSemanticHandlers,
} from "./NativeActorControllerWordRuntime.js";
export {
  createNativeActorFieldSemanticHandlers,
  createNativeActorFieldState,
  NativeActorFieldState,
} from "./NativeActorFieldRuntime.js";
export {
  createNativeActorOsagSemanticHandlers,
} from "./NativeActorOsagRuntime.js";
export {
  createNativeEventControlRecordSemanticHandlers,
} from "./NativeEventControlRecordRuntime.js";
export {
  createNativePrimaryRuntimeSemanticHandlers,
} from "./NativePrimaryRuntimeState.js";
export {
  createNativePresentationOwnerSemanticHandlers,
} from "./NativePresentationOwnerRuntime.js";
export {
  createNativeCollectionOperationSemanticHandlers,
} from "./NativeCollectionOperationState.js";
export {
  createNativeOperation01c7SemanticHandlers,
} from "./NativeOperation01c7Runtime.js";
export {
  createNativeDebugFormatSemanticHandlers,
} from "./NativeDebugFormatRuntime.js";
export {
  createNativeOperation017aSemanticHandlers,
} from "./NativeOperation017aRuntime.js";
export {
  createNativePresentationControllerFamilyAdapter,
  createNativePresentationControllerFamilySemanticHandlers,
  NativePresentationControllerFamilyAdapter,
} from "./NativePresentationControllerFamilyRuntime.js";
export {
  createNativeOperation016dSemanticHandlers,
  createNativeOperation016dState,
  NativeOperation016dState,
} from "./NativeOperation016dRuntime.js";
export {
  createNativeFaceClipControlSemanticHandlers,
  createNativeFaceClipControlState,
  NativeFaceClipControlState,
} from "./NativeFaceClipControlRuntime.js";
export {
  createNativeOperation0166SemanticHandlers,
  createNativeOperation0166State,
  NativeOperation0166State,
} from "./NativeOperation0166Runtime.js";
export {
  createNativeOperation019eSemanticHandlers,
  createNativeOperation019eState,
  NativeOperation019eState,
} from "./NativeOperation019eRuntime.js";
export {
  createNativeOperation0120SemanticHandlers,
  createNativeOperation0120State,
  NativeOperation0120State,
} from "./NativeOperation0120Runtime.js";
export {
  createNativeOperation001cSemanticHandlers,
  createNativeOperation001cState,
  NativeOperation001cState,
} from "./NativeOperation001cRuntime.js";
export {
  createNativeOperation008fSemanticHandlers,
  createNativeOperation008fState,
  NativeOperation008fState,
} from "./NativeOperation008fRuntime.js";
export {
  createNativeObjectImgmSelectionSemanticHandlers,
  createNativeObjectImgmSelectionState,
  NativeObjectImgmSelectionState,
} from "./NativeObjectImgmSelectionRuntime.js";
export {
  createNativeMomtVectorSlotSemanticHandlers,
  createNativeMomtVectorSlotState,
  NativeMomtVectorSlotState,
} from "./NativeMomtVectorSlotRuntime.js";
export {
  createNativeOperation0050SemanticHandlers,
  createNativeOperation0050State,
  NativeOperation0050State,
} from "./NativeOperation0050Runtime.js";
export {
  createNativeAreaRequestSemanticHandlers,
  createNativeAreaRequestState,
  NativeAreaRequestState,
} from "./NativeAreaRequestRuntime.js";
export {
  createNativeLightPresetSemanticHandlers,
  createNativeLightPresetState,
  NativeLightPresetState,
} from "./NativeLightPresetRuntime.js";
export {
  createNativeEnvironmentPresetSemanticHandlers,
  createNativeEnvironmentPresetState,
  NativeEnvironmentPresetState,
} from "./NativeEnvironmentPresetRuntime.js";
export {
  createNativeSceneOwnerFlagsSemanticHandlers,
  createNativeSceneOwnerFlagsState,
  NativeSceneOwnerFlagsState,
} from "./NativeSceneOwnerFlagsRuntime.js";
export {
  createNativeControllerInputSemanticHandlers,
  createNativeControllerInputState,
  NativeControllerInputState,
} from "./NativeControllerInputRuntime.js";
export {
  createNativeSecondaryMotionControlSemanticHandlers,
  createNativeSecondaryMotionControlState,
  NativeSecondaryMotionControlState,
} from "./NativeSecondaryMotionControlRuntime.js";
export {
  createNativeOperation0071SemanticHandlers,
} from "./NativeOperation0071Runtime.js";
export {
  createNativeOperation0170SemanticHandlers,
} from "./NativeOperation0170Runtime.js";
export {
  createNativeOperation019fSemanticHandlers,
  createNativeOperation019fState,
  NativeOperation019fState,
} from "./NativeOperation019fRuntime.js";
export {
  createNativeFixedGlobalByteSemanticHandlers,
} from "./NativeFixedGlobalByteRuntime.js";
export {
  createNativeSoundBankSemanticHandlers,
  reconcileNativeSoundBankSlots,
} from "./NativeSoundBankRuntime.js";
export {
  createNativeGameStateSemanticHandlers,
} from "./NativeGameStateRuntime.js";
export {
  createNativeClockRecordSemanticHandlers,
} from "./NativeClockRecordRuntime.js";
export {
  createNativeMapcRecordSemanticHandlers,
  createNativeMapcRecordState,
  NativeMapcRecordState,
} from "./NativeMapcRecordRuntime.js";
export {
  createNativeOperation0199SemanticHandlers,
} from "./NativeOperation0199Runtime.js";
export {
  createNativeOperation0174SemanticHandlers,
} from "./NativeOperation0174Runtime.js";
export {
  createNativeOperation01bdSemanticHandlers,
} from "./NativeOperation01bdRuntime.js";
export {
  createNativeNoOpSemanticHandlers,
} from "./NativeNoOpRuntime.js";
export {
  createNativeOperation014fSemanticHandlers,
} from "./NativeOperation014fRuntime.js";
export {
  createNativeCameraShakeSemanticHandlers,
  createNativeCameraShakeState,
  NativeCameraShakeState,
} from "./NativeCameraShakeRuntime.js";
export {
  createNativeHandMotionResourceSemanticHandlers,
  planNativeHandMotionResourceRequest,
} from "./NativeHandMotionResourceRuntime.js";
export {
  createNativeOperation013aSemanticHandlers,
} from "./NativeOperation013aRuntime.js";
export {
  createNativeOperation0052SemanticHandlers,
} from "./NativeOperation0052Runtime.js";
export {
  createNativeOperation0194SemanticHandlers,
} from "./NativeOperation0194Runtime.js";
export {
  createNativeOperation011aSemanticHandlers,
  createNativeOperation011aState,
  NativeOperation011aState,
} from "./NativeOperation011aRuntime.js";
export {
  createNativeOperation009bSemanticHandlers,
  createNativeOperation009bState,
  NativeOperation009bState,
} from "./NativeOperation009bRuntime.js";
export {
  createNativeOperation01adSemanticHandlers,
  createNativeOperation01adState,
  NativeOperation01adState,
  NATIVE_OPERATION_01AD_TABLE,
} from "./NativeOperation01adRuntime.js";
export {
  createNativeOperation01a1SemanticHandlers,
  createNativeOperation01a1State,
  NativeOperation01a1State,
} from "./NativeOperation01a1Runtime.js";
export {
  createNativeOperation0026SemanticHandlers,
  NATIVE_OPERATION_0026_GLOBAL_ADDRESS,
} from "./NativeOperation0026Runtime.js";
export {
  createNativeOperation0153SemanticHandlers,
  createNativeOperation0153State,
  NativeOperation0153State,
} from "./NativeOperation0153Runtime.js";
export {
  createNativeOperation0156SemanticHandlers,
  createNativeOperation0156State,
  NativeOperation0156State,
} from "./NativeOperation0156Runtime.js";
export {
  createNativeOperation018aSemanticHandlers,
  createNativeOperation018aState,
  NativeOperation018aState,
} from "./NativeOperation018aRuntime.js";
export {
  createNativeOperation014bSemanticHandlers,
  createNativeOperation014bState,
  NativeOperation014bState,
} from "./NativeOperation014bRuntime.js";
export {
  createNativeOperation015cSemanticHandlers,
  createNativeOperation015cState,
  NativeOperation015cState,
} from "./NativeOperation015cRuntime.js";
export {
  createNativeOperation0193SemanticHandlers,
  createNativeOperation0193State,
  NativeOperation0193State,
} from "./NativeOperation0193Runtime.js";
export {
  createNativeOperation013cSemanticHandlers,
  createNativeOperation013cState,
  NativeOperation013cState,
} from "./NativeOperation013cRuntime.js";
export {
  createNativeOperation013eSemanticHandlers,
  createNativeOperation013eState,
  NativeOperation013eState,
} from "./NativeOperation013eRuntime.js";
export {
  createNativeTransientSlotSemanticHandlers,
  createNativeTransientSlotState,
  NativeTransientSlotState,
} from "./NativeTransientSlotRuntime.js";
export {
  createNativeTmnmRecordSemanticHandlers,
  createNativeTmnmRecordState,
  NativeTmnmRecordState,
} from "./NativeTmnmRecordRuntime.js";
export {
  createNativeFaceControllerSemanticHandlers,
  createNativeFaceControllerState,
  NativeFaceControllerState,
} from "./NativeFaceControllerRuntime.js";
export {
  createNativeFixedRecordPoseSemanticHandlers,
} from "./NativeFixedRecordPoseRuntime.js";
export {
  createNativeScrollSpriteControlSemanticHandlers,
  createNativeScrollSpriteControlState,
  NativeScrollSpriteControlState,
} from "./NativeScrollSpriteControlRuntime.js";
export {
  createNativeInteractionManagerState,
  NativeInteractionManagerState,
} from "./NativeInteractionManagerState.js";

export function createNativeEventArgumentReader(
  action,
  context = {},
  resolveOperand = null,
) {
  return (index) => {
    const operand = action.arguments?.[index];
    if (!operand) {
      throw new Error(
        `${action.semanticId} native argument ${index} is missing`,
      );
    }
    if (["constant", "static-pointer", "function-pointer"].includes(operand.kind)) {
      return operand.value;
    }
    if (operand.kind === "frame-field") {
      const value = context.readFrameField?.(operand.offset);
      if (value === undefined) {
        throw new Error(
          `${action.semanticId} frame field ${operand.offset} is unavailable`,
        );
      }
      return value;
    }
    if (operand.kind === "scene-field") {
      const value = context.readSceneField?.(operand.offset);
      if (value === undefined) {
        throw new Error(
          `${action.semanticId} scene field ${operand.offset} is unavailable`,
        );
      }
      return value;
    }
    if (operand.kind === "operation-result") {
      const value = context.readOperationResult?.(operand.callFileOffset);
      if (value === undefined) {
        throw new Error(
          `${action.semanticId} operation result `
          + `${operand.callFileOffset} is unavailable`,
        );
      }
      return value;
    }
    if ([
      "integer-expression",
      "float32-truncate-to-signed-integer",
    ].includes(operand.kind)) {
      const value = exactNativeIntegerValue(operand, context);
      if (value === null) {
        throw new Error(
          `${action.semanticId} native integer expression ${index} is unavailable`,
        );
      }
      return value;
    }
    if (typeof resolveOperand !== "function") {
      throw new Error(
        `${action.semanticId} native argument ${index} is unresolved`,
      );
    }
    const value = resolveOperand(operand, {
      action,
      index,
      context,
    });
    if (value === undefined) {
      throw new Error(
        `${action.semanticId} native argument ${index} is unresolved`,
      );
    }
    return value;
  };
}

export function createNativeEventOperationExecutor({
  handlers = {},
  effectForOperation = null,
  effectRuntime = null,
  resolveOperand = null,
} = {}) {
  return async (action, context = {}) => {
    const handler = handlers[action.semanticId];
    if (typeof handler === "function") {
      return handler({
        action,
        context,
        readArgument: createNativeEventArgumentReader(
          action,
          context,
          resolveOperand,
        ),
      });
    }
    const template = effectForOperation?.(action, context);
    if (template) {
      if (!effectRuntime?.execute) {
        return {
          status: "stopped",
          reason: `effect-runtime-missing:${action.semanticId}`,
        };
      }
      const effect = materializeNativeGameplayEffect(
        template,
        (operand, detail) => resolveOperand?.(operand, {
          ...detail,
          action,
          context,
        }),
      );
      const result = await effectRuntime.execute([effect], context);
      return { status: "continued", effect, effectResult: result };
    }
    return {
      status: "stopped",
      reason: `semantic-handler-missing:${action.semanticId}`,
    };
  };
}

export function createNativeDialogueChannelSemanticHandlers({
  startDialogue,
  isDialogueActive,
} = {}) {
  return {
    "dialogue-start": async ({ action, context, readArgument }) => {
      if (typeof startDialogue !== "function") {
        return {
          status: "stopped",
          reason: "dialogue-start-adapter-missing",
        };
      }
      const started = await startDialogue({
        resourcePointer: readArgument(0),
        dialogueRegion: context.functionDefinition?.dialogueRegion ?? null,
        source: {
          functionFileOffset: context.location?.functionId,
          callFileOffset: action.callFileOffset,
        },
      });
      if (!started || !Object.hasOwn(started, "handle")) {
        return {
          status: "stopped",
          reason: "dialogue-start-did-not-return-handle",
        };
      }
      return started.request === undefined
        ? { result: started.handle }
        : {
            status: "yielded",
            request: started.request,
            result: started.handle,
          };
    },
    "dialogue-active-query": async ({ readArgument }) => {
      if (typeof isDialogueActive !== "function") {
        return {
          status: "stopped",
          reason: "dialogue-active-query-adapter-missing",
        };
      }
      const active = await isDialogueActive(readArgument(0));
      if (typeof active !== "boolean") {
        return {
          status: "stopped",
          reason: "dialogue-active-query-result-invalid",
        };
      }
      return { result: active ? 1 : 0 };
    },
  };
}

export function createNativeCoroutineSemanticHandlers({
  deactivateCoroutine,
} = {}) {
  return {
    "coroutine-deactivate-request": async ({
      action,
      context,
      readArgument,
    }) => {
      if (typeof deactivateCoroutine !== "function") {
        return {
          status: "stopped",
          reason: "coroutine-deactivate-adapter-missing",
        };
      }
      const target = readArgument(0);
      const current = target === 0;
      const deactivated = await deactivateCoroutine({
        handle: current ? null : target,
        current,
        currentHandle: context.coroutineHandle ?? null,
        source: {
          functionFileOffset: context.location?.functionId,
          callFileOffset: action.callFileOffset,
        },
      });
      if (typeof deactivated !== "boolean") {
        return {
          status: "stopped",
          reason: "coroutine-deactivate-result-invalid",
        };
      }
      return { result: deactivated ? 1 : 0 };
    },
  };
}

export function createNativeInteractionRecordSemanticHandlers({
  allocateInteractionManagerRuntimeSlot,
  consumeInteractionManagerRuntimeSlotStatus,
  queryNearestInteractionManagerDescriptor,
  queryInteractionManagerIndirectIndex,
  updateInteractionRecord,
  writeInteractionContextWord56,
} = {}) {
  const contextWordHandler = value => async ({ context }) => {
    const writeWord = (
      writeInteractionContextWord56
      || context.writeInteractionContextWord56
    );
    if (typeof writeWord !== "function") {
      return {
        status: "stopped",
        reason: "interaction-context-word-56-writer-missing",
      };
    }
    await writeWord(value);
    return { status: "continued" };
  };
  return {
    "interaction-manager-nearest-descriptor-query": async ({
      action,
      context,
    }) => {
      const query = (
        queryNearestInteractionManagerDescriptor
        || context.queryNearestInteractionManagerDescriptor
      );
      if (typeof query !== "function") {
        return {
          status: "stopped",
          reason: "interaction-manager-nearest-descriptor-query-missing",
        };
      }
      const operand = action.arguments?.[1];
      const targetWords = operand?.kind === "static-pointer"
        ? operand.staticWords
        : null;
      if (
        !Array.isArray(targetWords)
        || targetWords.length !== 3
        || targetWords.some(word => !Number.isInteger(word))
      ) {
        return {
          status: "stopped",
          reason: "interaction-manager-nearest-descriptor-target-unavailable",
        };
      }
      const result = await query(targetWords, 2);
      if (!Number.isInteger(result)) {
        return {
          status: "stopped",
          reason: "interaction-manager-state-unavailable",
        };
      }
      return { result };
    },
    "interaction-manager-runtime-slot-allocate": async ({
      context,
      readArgument,
    }) => {
      const allocate = (
        allocateInteractionManagerRuntimeSlot
        || context.allocateInteractionManagerRuntimeSlot
      );
      if (typeof allocate !== "function") {
        return {
          status: "stopped",
          reason: "interaction-manager-runtime-slot-allocator-missing",
        };
      }
      const result = await allocate(readArgument(1), readArgument(2));
      if (!Number.isInteger(result)) {
        return {
          status: "stopped",
          reason: "interaction-manager-runtime-slot-state-unavailable",
        };
      }
      return { result };
    },
    "interaction-manager-runtime-slot-status-consume": async ({
      context,
      readArgument,
    }) => {
      const consume = (
        consumeInteractionManagerRuntimeSlotStatus
        || context.consumeInteractionManagerRuntimeSlotStatus
      );
      if (typeof consume !== "function") {
        return {
          status: "stopped",
          reason: "interaction-manager-runtime-slot-status-consumer-missing",
        };
      }
      const result = await consume(readArgument(1));
      if (!Number.isInteger(result)) {
        return {
          status: "stopped",
          reason: "interaction-manager-runtime-slot-state-unavailable",
        };
      }
      return { result };
    },
    "interaction-manager-indirect-index-query": async ({
      context,
      readArgument,
    }) => {
      const query = (
        queryInteractionManagerIndirectIndex
        || context.queryInteractionManagerIndirectIndex
      );
      if (typeof query !== "function") {
        return {
          status: "stopped",
          reason: "interaction-manager-query-missing",
        };
      }
      const result = await query(readArgument(1), readArgument(2));
      if (!Number.isInteger(result)) {
        return {
          status: "stopped",
          reason: "interaction-manager-state-unavailable",
        };
      }
      return { result };
    },
    "interaction-context-word-56-set": contextWordHandler(1),
    "interaction-context-word-56-clear": contextWordHandler(0),
    "interaction-record-fields-write": async ({
      action,
      context,
      readArgument,
    }) => {
      const writeRecord = (
        updateInteractionRecord
        || context.updateInteractionRecord
      );
      if (typeof writeRecord !== "function") {
        return {
          status: "stopped",
          reason: "interaction-record-writer-missing",
        };
      }
      const index = readArgument(0);
      const values = Array.from(
        { length: 7 },
        (_, offset) => readArgument(offset + 1),
      );
      await writeRecord({
        index,
        values,
        source: {
          functionFileOffset: context.location?.functionId,
          callFileOffset: action.callFileOffset,
        },
      });
      return { status: "continued" };
    },
  };
}

export function createNativeGlobalWordSemanticHandlers({
  writeNativeWordBit,
  readNativeField,
  writeNativeField,
} = {}) {
  return {
    "fixed-global-float4-copy": async ({ action, context }) => {
      const writeField = writeNativeField || context.writeSceneField;
      if (typeof writeField !== "function") {
        return {
          status: "stopped",
          reason: "fixed-global-float4-writer-missing",
        };
      }
      const operand = action.arguments?.[0];
      let words;
      if (operand?.kind === "static-pointer") {
        words = operand.staticWords;
      } else if (
        operand?.kind === "frame-address"
        && Number.isInteger(operand.offset)
        && typeof context.readFrameField === "function"
      ) {
        words = [0, 4, 8, 12].map(
          offset => context.readFrameField(operand.offset + offset),
        );
      }
      if (
        !Array.isArray(words)
        || words.length !== 4
        || words.some(word => !Number.isInteger(word))
      ) {
        return {
          status: "stopped",
          reason: "fixed-global-float4-source-unavailable",
        };
      }
      const values = words.map(word => word >>> 0);
      for (let index = 0; index < values.length; index += 1) {
        await writeField({
          offset: 0x0c220330 + index * 4,
          width: 4,
          value: values[index],
        });
      }
      return {
        status: "continued",
        mutation: { address: 0x0c220330, words: values },
      };
    },
    "global-runtime-word-bit-5-control": async ({
      action,
      context,
      readArgument,
    }) => {
      const writeBit = writeNativeWordBit || context.writeNativeWordBit;
      if (typeof writeBit !== "function") {
        return {
          status: "stopped",
          reason: "native-word-bit-writer-missing",
        };
      }
      const mode = readArgument(0);
      if (mode !== 0 && mode !== 1) {
        return {
          status: "stopped",
          reason: "global-runtime-word-bit-5-mode-unproven",
        };
      }
      await writeBit({
        address: 0x0c20c3d4,
        mask: 0x20,
        enabled: mode === 0,
        source: {
          functionFileOffset: context.location?.functionId,
          callFileOffset: action.callFileOffset,
        },
      });
      return { status: "continued" };
    },
    "global-signed-word-divmod-10-query": async ({
      context,
      readArgument,
    }) => {
      const readField = readNativeField || context.readSceneField;
      if (typeof readField !== "function") {
        return {
          status: "stopped",
          reason: "native-signed-word-reader-missing",
        };
      }
      const mode = readArgument(0);
      if (mode !== 0 && mode !== 1) {
        return {
          status: "stopped",
          reason: "global-signed-word-divmod-mode-unproven",
        };
      }
      const value = await readField({
        offset: 0x0c22020c,
        width: 2,
      });
      if (!Number.isInteger(value)) {
        return {
          status: "stopped",
          reason: "native-signed-word-unavailable",
        };
      }
      const signedWord = ((value & 0xffff) << 16) >> 16;
      return {
        result: mode === 0
          ? signedWord % 10
          : Math.trunc(signedWord / 10),
      };
    },
    "fixed-global-dword-write": async ({
      context,
      readArgument,
    }) => {
      const writeField = writeNativeField || context.writeSceneField;
      if (typeof writeField !== "function") {
        return {
          status: "stopped",
          reason: "fixed-global-dword-writer-missing",
        };
      }
      const selector = readArgument(0);
      const addresses = {
        4: 0x0c22478c,
        5: 0x0c22483c,
      };
      const address = addresses[selector];
      if (address === undefined) {
        return {
          status: "stopped",
          reason: "fixed-global-dword-selector-unproven",
        };
      }
      const value = readArgument(1) >>> 0;
      await writeField({
        offset: address,
        width: 4,
        value,
      });
      return {
        result: -1,
        mutation: {
          address,
          width: 4,
          value,
        },
      };
    },
  };
}

export function createNativeNamedResourceSemanticHandlers({
  loadNamedResource,
  releaseNamedResource,
} = {}) {
  return {
    "named-resource-residency-control": async ({
      action,
      context,
      readArgument,
    }) => {
      const mode = readArgument(0);
      const resource = readArgument(1);
      const source = {
        functionFileOffset: context.location?.functionId,
        callFileOffset: action.callFileOffset,
      };
      if (mode === 0) {
        const release = (
          releaseNamedResource || context.releaseNamedResource
        );
        if (typeof release !== "function") {
          return {
            status: "stopped",
            reason: "named-resource-release-adapter-missing",
          };
        }
        await release(resource, source);
        return { result: 1 };
      }
      if (mode === 1) {
        const load = loadNamedResource || context.loadNamedResource;
        if (typeof load !== "function") {
          return {
            status: "stopped",
            reason: "named-resource-load-adapter-missing",
          };
        }
        const loaded = await load(resource, source);
        if (loaded === false) {
          return {
            status: "stopped",
            reason: "named-resource-load-incomplete",
          };
        }
        return { result: 1 };
      }
      return {
        status: "stopped",
        reason: "named-resource-residency-mode-unproven",
      };
    },
  };
}

export function createNativeSceneTransitionSemanticHandlers({
  writeSceneEightChannelTransition,
  isSceneEightChannelTransitionActive,
} = {}) {
  return {
    "scene-eight-channel-transition-write": async ({
      action,
      context,
      readArgument,
    }) => {
      const writeTransition = (
        writeSceneEightChannelTransition
        || context.writeSceneEightChannelTransition
      );
      if (typeof writeTransition !== "function") {
        return {
          status: "stopped",
          reason: "scene-eight-channel-transition-writer-missing",
        };
      }
      const duration = readArgument(0) >>> 0;
      const endpoints = [
        Array.from({ length: 4 }, (_, index) => (
          readArgument(index + 1) & 0xff
        )),
        Array.from({ length: 4 }, (_, index) => (
          readArgument(index + 5) & 0xff
        )),
      ];
      await writeTransition({
        duration,
        endpoints,
        source: {
          functionFileOffset: context.location?.functionId,
          callFileOffset: action.callFileOffset,
        },
      });
      return { status: "continued" };
    },
    "scene-eight-channel-transition-active-query": async ({ context }) => {
      const isActive = (
        isSceneEightChannelTransitionActive
        || context.isSceneEightChannelTransitionActive
      );
      if (typeof isActive !== "function") {
        return {
          status: "stopped",
          reason: "scene-eight-channel-transition-query-adapter-missing",
        };
      }
      const active = await isActive();
      if (typeof active !== "boolean") {
        return {
          status: "stopped",
          reason: "scene-eight-channel-transition-query-result-invalid",
        };
      }
      return { result: active ? 1 : 0 };
    },
  };
}
